import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export type FilterType = "all" | "kitchen" | "basement" | "bathroom" | "verified";

interface FilterTabsProps {
  activeFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
}

export function FilterTabs({ activeFilter, onFilterChange }: FilterTabsProps) {
  return (
    <nav aria-label="Lead filters" className="relative">
      {/* Left gradient fade indicator - mobile only */}
      <div className="absolute left-0 top-0 bottom-0 w-6 bg-gradient-to-r from-background to-transparent pointer-events-none z-10 sm:hidden" />

      <Tabs value={activeFilter} onValueChange={(v) => onFilterChange(v as FilterType)}>
        <TabsList className="bg-muted/50 w-full sm:w-auto overflow-x-auto flex justify-start sm:justify-center scrollbar-hide snap-x snap-mandatory">
          <TabsTrigger value="all" className="text-sm min-w-fit flex-shrink-0 snap-start h-10">
            All Leads
          </TabsTrigger>
          <TabsTrigger value="kitchen" className="text-sm min-w-fit flex-shrink-0 snap-start h-10">
            Kitchen
          </TabsTrigger>
          <TabsTrigger value="basement" className="text-sm min-w-fit flex-shrink-0 snap-start h-10">
            Basement
          </TabsTrigger>
          <TabsTrigger value="bathroom" className="text-sm min-w-fit flex-shrink-0 snap-start h-10">
            Bathroom
          </TabsTrigger>
          <TabsTrigger value="verified" className="text-sm min-w-fit flex-shrink-0 snap-start h-10">
            Verified Only
          </TabsTrigger>
        </TabsList>
      </Tabs>

      {/* Right gradient fade indicator - mobile only */}
      <div className="absolute right-0 top-0 bottom-0 w-6 bg-gradient-to-l from-background to-transparent pointer-events-none z-10 sm:hidden" />
    </nav>
  );
}
